module.exports = __webpack_public_path__ + "img/logo-tbth.34134d65.jpg";